import React from 'react'

import { FadeIn } from '@pb/components'

import styles from './UserMenuLoader.scss'

const UserMenuLoader: React.FC = () => (
  <FadeIn className={styles.container}>
    <div className={styles.title} data-testid="user-menu-loader" />
    <ul>
      <li />
      <li />
      <li />
      <li />
    </ul>

    <div className={styles.title} />
    <ul>
      <li />
      <li />
      <li />
    </ul>
  </FadeIn>
)

export default UserMenuLoader
